module.exports = createDomparser();

function createDomparser() {
  if (typeof DOMParser === 'undefined') {
    return {
      parseFromString: fail
    };
  }
  return new DOMParser();
}

function fail() {
  throw new Error('DOMParser is not supported by this platform. Please open issue here https://github.com/anvaka/simplesvg');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/simplesvg/lib/domparser.js
// module id = 98
// module chunks = 0